// removed by extract-text-webpack-plugin
module.exports = {"InfoScreenViewer":"_3yJLOjvbwkpL5Yg-44Kzx8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoScreenViewer/InfoScreenViewer.css
// module id = 490
// module chunks = 8